
// export const myGetter = ( state ) => {
//  return state
// }

export const outputdetailsList = state => state.outputdetails
export const outputdetailsSelectable = state => state.outputdetailsSelectable
export const outputdetailsPaginatedData = state => state.outputdetailsPaginatedData
export const outputdetail = state => state.outputdetail
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData
export const selectedListData = state => state.selectedListData
export const isSelecting = state => state.isSelecting
export const isSuccessMultiStoreOutputdetails = state => state.isSuccessMultiStoreOutputdetails
